import { State } from '../../schema';

export function constructFollowingSubStateId(userId: string) {
  return `${userId}-followings`;
}

export function getFollowingsSubStateId(state: State) {
  return constructFollowingSubStateId(state.id);
}
